












































































































































import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class AddFlightRuleModal extends Vue {
  dialog: boolean = true;

  passport: Date = null;
  birthday: Date = null;

  created() {}

  data() {
    return {
      range: [0, 70],

      flightClassItems: ["Economy"],
      flightClasses: [],

      flightSegmentItems: ["Y"],
      flightSegments: [],

      passengerTypeItems: ["Yetişkin", "Çocuk", "Bebek"],
      passengerTypes: [],

      salesChannelItems: ["Acente", "İnternet", "Momondo", "Skyscanner"],
      salesChannels: [],

      methodItems: [
        "1 - Sefer Tutar Kuralı",
        "2 - Gidiş Uçuş Kuralı",
        "3 - Sefer Fiyat Kuralı",
      ],
      methods: [],

      typeOfChangeItems: ["İndirim", "Zam"],
      typeOfChanges: [],

      calculationTypeItems: ["Oran", "Miktar"],
      calculationTypes: [],
    };
  }

  closeDialog() {
    this.$emit("closed");
  }
}
